/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2020-12-31 10:20:01
 */
import i18n from "../../../common/lang";
export const Columns=[
    {LabelName:i18n.t('lang.unusuallist.Serial'),key:0,ColumnsKey:'deviceSn',seek:'deviceSn',placeholder:i18n.t('lang.unusuallist.search1'), sort: 'custom'},
    {LabelName:i18n.t('lang.unusuallist.DeviceName'),key:1,ColumnsKey:'deviceName',seek:'deviceName',placeholder:i18n.t('lang.unusuallist.search2'), sort: 'custom'},
    {LabelName:i18n.t('lang.unusuallist.Version'),key:2,ColumnsKey:'deviceSoftwareVer',seek:'deviceSoftwareVer',placeholder:i18n.t('lang.unusuallist.search3'), sort: 'custom'},
    {LabelName:i18n.t('lang.unusuallist.DeleteTime'),key:3,ColumnsKey:'deviceUpdate',seek:'deviceUpdate',placeholder:i18n.t('lang.unusuallist.search4'), sort: 'custom'}
]

export const ColuumnsButton=[
    {key:0,type:'primary',icon:'icon-ziyuanxhdpi',Fun:'recoverfacility',Authority:108}
]